import InGameSpeed from "./InGameSpeed";

export default InGameSpeed;
